import styled from "styled-components";

export const StyledMatchTileWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 16px;

  .mls-c-status-stamp__status {
    position: absolute;
    top: 12.5%;
    &.-live {
      top: 6.5%;
    }
    &.-delay,
    &.-canc,
    &.-aban,
    &.-ppd {
      top: 45%;
      color: #808080;
      font-size: ${(props) => props.theme.mixins.pxToRem(11)};
    }
    &.-delay {
      top: 30%;
    }
    &.-aban {
      top: 15%;
    }
  }

  .mls-c-match-tile {
    display: flex;
    align-items: center;
    width: 100%;
    box-sizing: border-box;
    justify-content: space-between;
    padding: 0 8px;
    font-family: ${(props) =>
      props.theme.figma.base.fontfamily_mlstifo_standard};
    font-weight: bold;
    font-size: ${(props) => props.theme.mixins.pxToRem(18)};
    line-height: 18px;
    color: ${(props) => props.theme.figma.base.color_offblack_100};

    &.--post .--home-loser,
    &.--post .--away-loser {
      color: ${(props) => props.theme.figma.base.color_offblack_50};
    }

    &.--canc,
    &.--ppd {
      .mls-c-scorebug {
        display: none;
      }
    }

    .mls-c-club.--home,
    .mls-c-club.--away {
      flex-direction: column;
      flex: 1;
      height: 100%;
      max-width: 110px;
      .mls-c-club__shortname,
      .mls-c-club__abbreviation {
        margin: 0;
        text-align: center;
      }
    }

    .mls-c-club__picture {
      margin-top: 4px;
      max-width: 84px;
      max-height: 84px;
      width: 100%;
    }

    .mls-c-scorebug {
      display: flex;
      flex-direction: column;
      align-items: center;
      transform: scale(1.25);
      gap: 4px;
      padding-bottom: 12px;
    }

    &.--pre,
    &.--delay {
      .mls-c-scorebug {
        transform: scale(1.75);
        padding-bottom: 0;
        & span {
          color: ${(props) => props.theme.figma.base.color_black_100};
        }
      }
    }
  }
  &.xxs {
    .mls-c-club__shortname {
      display: none;
    }
    .mls-c-match-tile {
      padding: 0;
      .mls-c-scorebug {
        padding-bottom: 0;
      }
      .mls-c-club {
        max-width: 80px;
      }
    }
  }

  &.xs {
    .mls-c-club__shortname {
      bottom: 0;
    }
    .mls-c-club.--home,
    .mls-c-club.--away {
      min-height: 114px;
    }
  }

  &.xs,
  &.sm,
  &.md,
  &.lg,
  &.xl,
  &.xxl {
    .mls-c-club__abbreviation {
      display: none;
    }
  }
`;
